import { Card, CardContent, CardHeader, Grid, Typography } from '@mui/material';

function Complete() {
  return (
    <Card variant="outlined">
      <CardHeader title="Membership Enrollment Applicaton Complete" titleTypographyProps={{ textAlign: "center" }} />
      <CardContent >
          <Grid item container xs={12}  spacing={2}>
              <Grid item xs={1} md={2} lg={4} ></Grid>
              <Grid item xs={10} md={8} lg={4} >
                  <Typography variant="body1" color="textPrimary" align="center">
                      Thank you for submitting your application for membership. Your application is now being processed. You will receive an email confirmation shortly.
                  </Typography>
              </Grid>
              <Grid item xs={1} md={2} lg={4} ></Grid>
            </Grid>
            <Grid item container xs={12}  spacing={2}>
              <Grid item xs={1} md={2} lg={4} ></Grid>
              <Grid item xs={10} md={8} lg={4} >
                  <Typography variant="body1" color="textPrimary" align="center">
                      If you have any questions or need further assistance, please contact your local union or chapter.                
                  </Typography>
              </Grid>
              <Grid item xs={1} md={2} lg={4} ></Grid>
          </Grid>
      </CardContent>
    </Card>
  );
}

export default Complete;